export default [
  {
    path: '/downloadZone',
    redirect: '/downloadZone/fileDownload',
    component: () => import('@/views/download-zone/index.vue'),
    children: [
      {
        path: 'fileDownload',
        name: 'file-download',
        component: () => import('@/views/download-zone/file-download/index.vue'),
        meta: {
          title: '文件下载',
        },
      },
      {
        path: 'tableDownload',
        name: 'table-download',
        component: () => import('@/views/download-zone/table-download/index.vue'),
        meta: {
          title: '表格下载',
        },
      },
    ],
  },
  {
    path: '/downloadZone/detail',
    name: 'downloadZone-detail',
    component: () => import('@/views/download-zone/detail.vue'),
    meta: {
      title: '文件下载',
      hiddenCarousel: true,
    },
  },
];

